import React, { Fragment } from 'react';

import './list.scss';
import { $window, classSet } from '@umu/umu-dom';
import { IListItem, EPlatformTravelType as TravelType, EPlatformSectionType as SectionType } from '@umu/umu-types';
import { components } from 'common';
import { formatDepartmentName, onAllowPermissionSwitch } from '../../utils';
import { UserAvatar } from '../../../user';
import { EnterpriseRoleType } from '@umu/umu-types';

import deleteIcon from '../../images/icon-delete.png';
import topIcon from '../../images/icon-top.png';
import fileIcon from '../../images/icon-file.png';
import rightIcon from '../../images/icon-right.png';
import departmentMemberIcon from '../../images/icon-department-member.png';
const iconUnKnownCheck = require('../../images/icon-unknown-check.png');
const iconUnCheck = require('../../images/icon-un-check.png');
const iconCheck = require('../../images/icon-check.png');
interface IProps {
    itemData: IListItem;
    travelType: TravelType;
    sectionType: SectionType;
    index: number;
    selectedNum: number;
    isSearchMode: boolean;
    enterpriseName: string;
    isShowMember?: boolean;
    checkableRoot?: boolean;
    limit?: number;
    hasAllPermissionRoles: EnterpriseRoleType[];
    onShowPopName: (isShow: boolean, left: number, top: number, fullName: string) => void;
    onSelectedChange: (params: IListItem, isChecked: boolean) => void;
    onNextLevel: (params: IListItem) => void;
    onClickRemove: (params: IListItem) => void;
    onToggleName: (params: IListItem) => void;
}
export enum CHECKBOX_CHECK_TYPE {
    UN_CHECK,
    IS_CHECK,
    UNKNOWN_CHECK,
}
type ICheckboxMap = {
    [propName in CHECKBOX_CHECK_TYPE]: string;
};
interface ICheckboxProps {
    isChecked: CHECKBOX_CHECK_TYPE;
    disabledCheck?: boolean;
    onChange: (isCheck: boolean) => void;
}

const checkboxMap: ICheckboxMap = {
    [CHECKBOX_CHECK_TYPE.UN_CHECK]: iconUnCheck,
    [CHECKBOX_CHECK_TYPE.IS_CHECK]: iconCheck,
    [CHECKBOX_CHECK_TYPE.UNKNOWN_CHECK]: iconUnKnownCheck,
};
const { If } = components;
const { PreImg } = components;

/**
 * 临时方案展示勾选框
 */
export const Checkbox = (props: ICheckboxProps) => {
    const { isChecked, disabledCheck = false, onChange } = props;
    const onClick = () => {
        if (!disabledCheck) {
            onChange(!isChecked);
        }
    };
    return (
        <PreImg>
            <img
                onClick={onClick}
                className={classSet({
                    'icon-img-check': true,
                    'icon-img-check-unknown': isChecked === CHECKBOX_CHECK_TYPE.UNKNOWN_CHECK,
                    'icon-disabled-check': disabledCheck,
                })}
                src={checkboxMap[isChecked]}
            />
        </PreImg>
    );
};
export const ListItem = (props: IProps) => {
    const listChildren: any[] = [];
    let fnMouseHandleId: number | undefined;
    const listItemData = props.itemData;
    const { selectedNum, hasAllPermissionRoles } = props;

    const onMouseEnterHandle = (e: any, fullName: string) => {
        if (!e || !e.target) {
            return;
        }
        e.persist();
        if (!e.target) {
            return;
        }
        $window.clearTimeout(fnMouseHandleId);
        fnMouseHandleId = $window.setTimeout(() => {
            const offsetLeft: number = e.target.offsetLeft + e.target.offsetWidth / 2;
            const offsetTop: number = e.target.offsetTop + e.target.offsetHeight + 5;
            props.onShowPopName(true, offsetLeft, offsetTop, fullName);
        }, 500);
    };

    const onMouseLeaveHandle = () => {
        $window.clearTimeout(fnMouseHandleId);
        fnMouseHandleId = $window.setTimeout(() => {
            props.onShowPopName(false, -1, -1, '');
        }, 100);
    };

    const ListItemDepartmentLeft = (params: IListItem, key: React.Key) => {
        const isSelected = params.isSelected;
        const fullName: string = formatDepartmentName(
            false,
            props.enterpriseName,
            params.name,
            params.id,
            params.oriData && params.oriData.parent_path,
        );
        const sampleName: string = formatDepartmentName(
            true,
            props.enterpriseName,
            params.name,
            params.id,
            params.oriData && params.oriData.parent_path,
        );
        const isDisabledCheck = onAllowPermissionSwitch(params.oriData, hasAllPermissionRoles);
        const isAllowClick = params.checkable && !isDisabledCheck;
        const renderDepartmentMember = () => {
            const count = params.oriData ? params.oriData.member_count : 0;
            return props.isShowMember ? (
                <PreImg>
                    <Fragment>
                        <img className="content-file icon-member" src={departmentMemberIcon} alt="" />
                        <span className="member-count">{count}</span>
                    </Fragment>
                </PreImg>
            ) : null;
        };
        return (
            <li className="list-item" key={key}>
                <div className="content">
                    <div className="content-empty"></div>
                    <div className="content-check">
                        <Checkbox
                            isChecked={isSelected ? CHECKBOX_CHECK_TYPE.IS_CHECK : CHECKBOX_CHECK_TYPE.UN_CHECK}
                            onChange={(isChecked) => props.onSelectedChange(params, isChecked)}
                            disabledCheck={!isAllowClick || (!isSelected && !!props.limit && selectedNum >= props.limit)}
                        />
                    </div>
                    <PreImg>
                        <img className="content-file" src={params.id === '0' ? topIcon : fileIcon} alt="" />
                    </PreImg>
                    <If condition={props.isSearchMode}>
                        <div className="deepart-member">
                            <span
                                className="name"
                                onMouseEnter={(e: any) => onMouseEnterHandle(e, fullName)}
                                onMouseLeave={() => onMouseLeaveHandle()}
                                onClick={() => isAllowClick && props.onToggleName(params)}
                            >
                                {sampleName}
                            </span>
                            {renderDepartmentMember()}
                        </div>
                    </If>
                    <If condition={!props.isSearchMode}>
                        <div className="deepart-member">
                            <span className="name name-left" onClick={() => isAllowClick && props.onToggleName(params)} onMouseEnter={(e: any) => onMouseEnterHandle(e, fullName)}
                        onMouseLeave={() => onMouseLeaveHandle()}>
                                {params.name}
                            </span>
                            {renderDepartmentMember()}
                        </div>
                    </If>

                    <div className="close">
                        <If condition={(!props.isSearchMode && params.isHaveNextLevel) || false}>
                            <PreImg>
                                <img src={rightIcon} alt="" onClick={() => props.onNextLevel(params)} />
                            </PreImg>
                        </If>
                    </div>
                </div>
            </li>
        );
    };

    const ListItemDepartmentRight = (params: IListItem, key: React.Key) => {
        const fullName: string = formatDepartmentName(
            false,
            props.enterpriseName,
            params.name,
            params.id,
            params.oriData && params.oriData.parent_path,
        );
        const sampleName: string = formatDepartmentName(
            true,
            props.enterpriseName,
            params.name,
            params.id,
            params.oriData && params.oriData.parent_path,
        );
        const isRootDepartment = `${params.id}` === '0';
        const isHideClose = onAllowPermissionSwitch(params.oriData, hasAllPermissionRoles) && !(props.checkableRoot && isRootDepartment)
        return (
            <li className="list-item" key={key}>
                <div className="content">
                    <PreImg>
                        <img className="content-file" src={params.id === '0' ? topIcon : fileIcon} alt="" />
                    </PreImg>
                    <span
                        className="name"
                        onMouseEnter={(e: any) => onMouseEnterHandle(e, fullName)}
                        onMouseLeave={() => onMouseLeaveHandle()}
                    >
                        {sampleName}
                    </span>
                    <If condition={!isHideClose}>
                        <PreImg>
                            <img
                                className="close"
                                src={deleteIcon}
                                alt=""
                                onClick={() => props.onClickRemove(params)}
                            />
                        </PreImg>
                    </If>
                </div>
            </li>
        );
    };

    const ListItemOwnerLeft = (params: IListItem, key: React.Key) => {
        const isSelected = params.isSelected;
        const userAvatar = (
            <div className="avatar">
                <UserAvatar src={params.avatar || ''} className="data-user-avatar" width={32} />
            </div>
        );

        return (
            <li className="list-item list-item-owner" key={key}>
                <div className="content">
                    <div className="content-check">
                        <Checkbox
                            isChecked={isSelected ? CHECKBOX_CHECK_TYPE.IS_CHECK : CHECKBOX_CHECK_TYPE.UN_CHECK}
                            onChange={(isChecked) => props.onSelectedChange(params, isChecked)}
                            disabledCheck={false}
                        />
                    </div>
                    {userAvatar}
                    <span className="name  name-left" onClick={() => params.checkable && props.onToggleName(params)}>
                        {params.name}
                    </span>
                </div>
            </li>
        );
    };

    const ListItemOwnerRight = (params: IListItem, key: React.Key) => {
        const userAvatar = (
            <div className="avatar">
                <UserAvatar src={params.avatar || ''} className="data-user-avatar" width={32} />
            </div>
        );

        return (
            <li className="list-item-owner list-item" key={key}>
                <div className="content">
                    {userAvatar}
                    <span className="name">{params.name}</span>
                    <PreImg>
                        <img className="close" src={deleteIcon} alt="" onClick={() => props.onClickRemove(params)} />
                    </PreImg>
                </div>
            </li>
        );
    };

    if (props.travelType === TravelType.department && props.sectionType === SectionType.left) {
        listChildren.push(ListItemDepartmentLeft(listItemData, props.index));
    } else if (props.travelType === TravelType.department && props.sectionType === SectionType.right) {
        listChildren.push(ListItemDepartmentRight(listItemData, props.index));
    } else if (props.travelType === TravelType.owner && props.sectionType === SectionType.left) {
        listChildren.push(ListItemOwnerLeft(listItemData, props.index));
    } else if (props.travelType === TravelType.owner && props.sectionType === SectionType.right) {
        listChildren.push(ListItemOwnerRight(listItemData, props.index));
    }

    return <ul className="list-ul">{listChildren}</ul>;
};
